import { SupportedFilterList } from './types';

export const supportedFilters: SupportedFilterList = [
  { field: 'sector', label: 'Sector' },
  { field: 'geography', label: 'Geography' },
  { field: 'activity_type', label: 'Activity type' },
  { field: 'isic_section', label: 'ISIC Section' },
  { field: 'isic_class', label: 'ISIC Class' },
];
